import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, Tabs } from 'antd';
import { Table, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { IFinanceDataView, IFinanceTimeGroup, IFinanceRecordData, getDataView, IFinanceIncomeTypeGroup, IFinanceOutcomeTypeGroup } from '../../service/api/financeRecord';
import moment from 'moment';
import { FormInstance } from 'antd/lib/form/Form';
import { IStore, listStores } from '../../service/api/store';
const { confirm } = Modal;
const { Option } = Select;
const { RangePicker } = DatePicker;

interface ITeachClassListProps {
  visible: boolean
  setVisible: (visible: boolean) => void;
}
const FinanceDataList: React.FC<ITeachClassListProps> = ({
  visible,
  setVisible,
}) => {
  const [dataView, setDataView] = useState<IFinanceDataView>();
  const [stores, setStores] = useState<IStore[]>();
  const [storeId, setStoreId] = useState<number>();
  const [startDate, setStartDate] = useState<string>();
  const [endDate, setEndDate] = useState<string>();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    getDataView(startDate, endDate, storeId).then((info: any) => {
      setDataView(info?.data);
    });
    listStores().then((info: any) => {
      setStores(info?.data);
    });
  }

  const handleSelectTime = (value: any, dateString: any) => {
    console.log('选择的时间：', value)
    console.log('选择的时间：', dateString)
    if (value) {
      setStartDate(moment(new Date(value[0])).format('YYYY-MM-DD'));
      setEndDate(moment(new Date(value[1])).format('YYYY-MM-DD'));
    } else {
      setStartDate(undefined);
      setEndDate(undefined);
    }
  }

  const columns = [
    {
      title: 'name',
      dataIndex: 'messageName',
      key: 'messageName',
    },{
      title: 'value',
      dataIndex: 'messageValue',
      key: 'messageValue',
    }];

  // 下拉框值
  const storeOptions = stores?.map((store) =>
    <Option key={store.id} value={store.id}>{store.name}</Option>);

  const loadTimeGroup = dataView?.timeGroups?.map((monthGroup: IFinanceTimeGroup) => {
    return <Card size="small" title={monthGroup.month} bordered={false} style={{ minWidth: '330px', marginRight: '10px', border: "1px solid #F0EFEF" }}>
      支出金额：{monthGroup.outcome}&nbsp;&nbsp;&nbsp;&nbsp;收入金额：{monthGroup.income}&nbsp;&nbsp;&nbsp;&nbsp;<br />
      财务记录数：{monthGroup.recordCount}&nbsp;&nbsp;&nbsp;&nbsp;净余结：{monthGroup.netProfits} &nbsp;&nbsp;&nbsp;&nbsp;
      <hr />
      {monthGroup.financeRecords.length != 0 ?
        <Table dataSource={monthGroup.financeRecords} columns={columns} pagination={false} showHeader={false} size="small"/>
        : '暂无数据'
      }
    </Card>
  })

  const loadIncomeTypeGroup = dataView?.incomeTypeGroups?.map((incomeTypeGroup: IFinanceIncomeTypeGroup) => {
    return <Card size="small" title={incomeTypeGroup.name} bordered={false} style={{ minWidth: '330px', marginRight: '10px', border: "1px solid #F0EFEF" }}>
      收入金额：{incomeTypeGroup.income}&nbsp;&nbsp;&nbsp;&nbsp;财务记录数：{incomeTypeGroup.recordCount}&nbsp;&nbsp;&nbsp;&nbsp;
      <hr />
      {incomeTypeGroup.financeRecords.length != 0 ?
         <Table dataSource={incomeTypeGroup.financeRecords} columns={columns} pagination={false} showHeader={false} size="small"/>
         : '暂无数据'
      }
    </Card>
  })

  const loadOutcomeTypeGroup = dataView?.outcomeTypeGroups?.map((outcomeTypeGroup: IFinanceOutcomeTypeGroup) => {
    return <Card size="small" title={outcomeTypeGroup.name} bordered={false} style={{ minWidth: '330px', marginRight: '10px', border: "1px solid #F0EFEF" }}>
      支出金额：{outcomeTypeGroup.outcome}&nbsp;&nbsp;&nbsp;&nbsp;财务记录数：{outcomeTypeGroup.recordCount}&nbsp;&nbsp;&nbsp;&nbsp;
      <hr />
      {outcomeTypeGroup.financeRecords.length != 0 ?
       <Table dataSource={outcomeTypeGroup.financeRecords} columns={columns} pagination={false} showHeader={false} size="small"/>
       : '暂无数据'
      }
    </Card>
  })

  return (
    <Card bordered={false} style={{ display: "flex" }}>
      <div style={{ display: "flex" }}>
        <Card bordered={true} style={{ width: '740px', height: '80px', borderColor: '#F0EFEF' }}>
          <span style={{ fontSize: '14px' }}>支出金额：</span><span style={{ fontSize: '22px' }}>{dataView?.totalOutcome}&nbsp;&nbsp;&nbsp;</span>
          <span style={{ fontSize: '14px' }}>收入金额：</span><span style={{ fontSize: '22px' }}>{dataView?.totalIncome}&nbsp;&nbsp;&nbsp;</span>
          <span style={{ fontSize: '14px' }}>财务记录数：</span><span style={{ fontSize: '14px' }}>{dataView?.totalRecordCount}&nbsp;&nbsp;&nbsp;</span>
          <span style={{ fontSize: '14px' }}>净余结：</span><span style={{ fontSize: '22px' }}>{dataView?.totalNetProfits}</span>
        </Card>
        <Card bordered={true} style={{ width: '630px', height: '80px', borderColor: '#F0EFEF', marginLeft: '20px' }}>
          <RangePicker
            format="YYYY-MM-DD"
            onChange={handleSelectTime}
          />
          <Select placeholder="全部校区"
            style={{ width: 160, marginLeft: '20px' }} onChange={(value) => {
              setStoreId(Number(value));
            }} allowClear>
            {storeOptions}
          </Select>
          <Button type="ghost" style={{ width: 100, marginLeft: '20px' }} icon={<SearchOutlined />} onClick={() => {
            loadData();
          }}>搜索</Button>
        </Card>
      </div>
      <div style={{ display: "flex", marginTop: '5px' }}>
        <div style={{ width: '100px', height: '5px', backgroundColor: '#EA0000', alignSelf: 'center' }}></div>
        <div style={{ fontWeight: 'bold' }}>&nbsp;按月汇总&nbsp;</div>
        <div style={{ width: '100px', height: '5px', backgroundColor: '#EA0000', alignSelf: 'center' }}></div>
      </div>
      <div style={{ display: "flex", width: '1390px', marginTop: '5px', overflow: 'scroll' }}>
        {loadTimeGroup}
      </div>
      <div style={{ display: "flex", marginTop: '5px' }}>
        <div style={{ width: '100px', height: '5px', backgroundColor: 'orange', alignSelf: 'center' }}></div>
        <div style={{ fontWeight: 'bold' }}>&nbsp;收入类型汇总&nbsp;</div>
        <div style={{ width: '100px', height: '5px', backgroundColor: 'orange', alignSelf: 'center' }}></div>
      </div>
      <div style={{ display: "flex", width: '1390px', marginTop: '5px', overflow: 'scroll' }}>
        {loadIncomeTypeGroup}
      </div>
      <div style={{ display: "flex", marginTop: '5px' }}>
        <div style={{ width: '100px', height: '5px', backgroundColor: '#005AB5', alignSelf: 'center' }}></div>
        <div style={{ fontWeight: 'bold' }}>&nbsp;支出类型汇总&nbsp;</div>
        <div style={{ width: '100px', height: '5px', backgroundColor: '#005AB5', alignSelf: 'center' }}></div>
      </div>
      <div style={{ display: "flex", width: '1390px', marginTop: '5px', overflow: 'scroll' }}>
        {loadOutcomeTypeGroup}
      </div>
      {/* <Table dataSource={data} columns={columns} pagination={false} scroll={{ x: 'true' }}/> */}
      <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "10px" }} />
    </Card>
  );
};

export default FinanceDataList;
